export const swiperArchivePickup = () => {
  const el = document.querySelector(".js-swiper-archive-pickup");
  if (!el) return;

  new Swiper(el, {
    slidesPerView: "auto",
    spaceBetween: 32,
    centeredSlides: true,
    loop: true,
    pagination: {
      el: ".p-archive-pickup__pagination",
      clickable: true,
    },
    breakpoints: {
      1025: {
        slidesPerView: 3,
        spaceBetween: 48,
      },
    },
  });
};
